import {Component, EventEmitter, HostBinding, Input, OnInit, Output} from '@angular/core';
import {TYPE} from '../../models/type.enum';
import {InBaseFrwComponent} from '../inBaseFrwComponent';

@Component({
  selector: 'cmp-button',
  template: `<button type="button"
        *ngIf="type"
        [class]="classDefault + customClass"
        [disabled]="isDisabled"
        (click)="onClick.emit(null)"
        [class.cursor-pointer]="!isDisabled"
        [class.cursor-not-allowed]="isDisabled">
  <ng-content></ng-content>
</button>
`,
  styles: [``]
})
export class ButtonDefaultComponent extends InBaseFrwComponent implements OnInit {

  classDefault = 'btn btn-xs font-weight-light ml-1';
  @Input() type: TYPE = TYPE.PRIMARY;
  @Input() outline = false;
  @Input() class = '';
  @Input() classes = '';
  @Input() isDisabled = false;
  @Output() onClick = new EventEmitter();

  constructor() {
    super();
  }

  ngOnInit() {

  }

  get customClass() {
    this.classes = this.classDefault;
    this.classes += ` btn-${this.outline ? ('outline-' + this.type) : this.type } ${this.class}`;
    return this.classes;
  }
}
